/**
 * `?next=` yalnız uygulama içi yoldur (panelin S09-K3 kuralı): `/` ile başlar, `//` ya da `/\` ile başlamaz, şema ve
 * denetim karakteri taşımaz. Geçersizse `null` döner ve çağıran rolün ana sayfasına gider. Oturum ekranlarına dönüş de
 * reddedilir.
 */
export function safeNext(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  let path = value.trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    return null;
  }

  if (!path.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) {
    return null;
  }

  for (const char of path) {
    const code = char.charCodeAt(0);
    if (code < 0x20 || code === 0x7f || char === '\\') {
      return null;
    }
  }

  const url = new URL(path, 'https://backoffice.invalid');
  if (url.origin !== 'https://backoffice.invalid') {
    return null;
  }

  const authPaths = ['/login', '/activate'];
  if (authPaths.some((auth) => url.pathname === auth || url.pathname.startsWith(`${auth}/`))) {
    return null;
  }

  return `${url.pathname}${url.search}${url.hash}`;
}

/** Oturum açma adresi: şu anki yol `next` olarak taşınır (kök yolda gerek yok). */
export function loginPath(currentPath: string): string {
  const next = safeNext(currentPath);
  return next && next !== '/' ? `/login?next=${encodeURIComponent(next)}` : '/login';
}
